import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { TagSubtypes } from "core/queries/GetTags";
import {
  GetTeam_userConnections_users_dispatchRoles as DispatchRolesGenerated,
  GetTeam as GetTeamGenerated,
  GetTeamVariables as GetTeamVariablesGenerated,
  GetTeam_userConnections_users_tags as TagDataGenerated,
  GetTeam_userConnections_users as UserDataGenerated,
} from "core/queries/__generated__/GetTeam";
import { SquadTag } from "typings/globalGQLTypes";

export interface DispatchRolesData extends DispatchRolesGenerated {}
export interface TagData extends TagDataGenerated {}
export interface UserData extends UserDataGenerated {}
export interface GetTeamResponse extends GetTeamGenerated {}
export interface GetTeamVariables extends GetTeamVariablesGenerated {}

// SquadTag enum needs to be mapped for some values to fit TagsToIcons
export const mapSquadToTagName = (tag: SquadTag) => {
  switch (tag) {
    case SquadTag.MaintenancePM:
      return TagSubtypes.Maintenance;
    default:
      return TagSubtypes[tag];
  }
};

export const teamUserFragment = gql`
  fragment TeamUser on User {
    id
    name
    firstName
    lastName
    email
    avatar: profilePicture {
      id
      url
    }
    dispatchRoles {
      displayName
      name
      toolTip
    }
    tags {
      id
      name
      tagType
    }
    tomTeamMember {
      id
      city {
        id
        name
        timezone
      }
    }
    roles
  }
`;
export const getTeam = gql`
  query GetTeam($filter: UserFilterInput!, $sort: [UserSortInput!]) {
    userConnections(filter: $filter, sort: $sort) {
      users {
        id
        ...TeamUser
      }
    }
  }
  ${teamUserFragment}
`;

export interface UseGetTeamQueryOptions {
  skip: boolean;
  variables: GetTeamVariables;
}

export const useGetTeamQuery = ({
  skip = false,
  variables,
}: UseGetTeamQueryOptions) =>
  useQuery<GetTeamResponse, GetTeamVariables>(getTeam, {
    skip,
    variables,
  });
